import React from "react";
import cashIcon from "../../../../assets/receptionistIcons/ipBilling/cash.svg";
import upiIcon from "../../../../assets/receptionistIcons/ipBilling/upi.svg";
import cardIcon from "../../../../assets/receptionistIcons/ipBilling/card.svg";
import chequeIcon from "../../../../assets/receptionistIcons/ipBilling/cheque.svg";
import impsIcon from "../../../../assets/receptionistIcons/ipBilling/imps.svg";
import rtgsIcon from "../../../../assets/receptionistIcons/ipBilling/rtgs.svg";
import neftIcon from "../../../../assets/receptionistIcons/ipBilling/neft.svg";
import styles from "./BillingIp.module.css";
import {
  PAYMENT_MODE_LABELS,
  SELECTABLE_PAYMENT_MODES,
} from "../../../../helpers/paymentModes";

const MODE_ICONS = {
  cash: cashIcon,
  upi: upiIcon,
  card: cardIcon,
  cheque: chequeIcon,
  imps: impsIcon,
  rtgs: rtgsIcon,
  neft: neftIcon,
};

export const PAYMENT_MODES = SELECTABLE_PAYMENT_MODES.map((value) => ({
  value,
  label: PAYMENT_MODE_LABELS[value],
  icon: MODE_ICONS[value],
}));

const PaymentModeSelector = ({ value, onChange }) => {
  return (
    <div
      className={styles.paymentModes}
      role="group"
      aria-label="Payment mode"
    >
      {PAYMENT_MODES.map((mode) => {
        const isActive = value === mode.value;
        return (
          <button
            key={mode.value}
            type="button"
            aria-pressed={isActive}
            className={`${styles.modeBtn} ${isActive ? styles.modeBtnActive : ""}`}
            onClick={() => onChange?.(mode.value)}
          >
            <img src={mode.icon} alt="" className={styles.modeIcon} />
            <span>{mode.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default PaymentModeSelector;
